'use client';

import dynamic from 'next/dynamic';
const Tabs = dynamic(() => import('de-sxm-reactlib-2/components/atoms/Layout/Tabs/Tabs'));
import { type TabsProps } from 'de-sxm-reactlib-2/components/atoms/Layout/Tabs';

export default function ClientTabsGroup({ items, navLayout, id }: TabsProps): React.JSX.Element {
    return <Tabs items={items} navLayout={navLayout} id={id} />;
}
